<template>
  <LcCard
    :aria-disabled="!enabled"
    body-class="p-none"
    class="prize-banner mx-100"
    role="button"
    shadow="large"
    :tabindex="enabled ? 0 : -1"
    v-bind="{ ariaLabel }"
    @click="openModal"
    @keydown.enter.prevent="openModal"
    @keydown.space.prevent="openModal"
  >
    <PrizeBannerInner
      class="px-200 py-100 rounded-m"
      :class="{ 'inner-enabled': enabled }"
      v-bind="{ drawLabel, headline, odds, visibleJackpot }"
      variant="banner"
    >
      <Transition name="fade">
        <LcIcon v-if="enabled" class="open-icon" name="chevron-right" size="small" />
      </Transition>
    </PrizeBannerInner>
  </LcCard>
</template>

<script lang="ts" setup>
type Emits = {
  (e: 'click'): void
}

type Props = {
  ariaLabel: string
  drawLabel?: string
  enabled: boolean
  headline: string
  odds?: string
  visibleJackpot?: Money | undefined
}

defineOptions({
  inheritAttrs: false,
})

const emit = defineEmits<Emits>()
const { enabled } = defineProps<Props>()

const openModal = () => {
  if (!enabled) return
  emit('click')
}
</script>

<style lang="scss" scoped>
.prize-banner {
  .inner-enabled {
    cursor: pointer;
  }

  .open-icon {
    position: absolute;
    top: 50%;
    right: token('size/space/gap/200');
    width: 1.5rem;
    height: 1.5rem;
    border-radius: token('size/radius/m');
    background-color: token('color/background/accent/win/win-bold');
    box-shadow: token('shadow/shadow/card/small');
    color: token('color/icon/primary/primary');
    font-size: 1.5rem;
    transform: translateY(-50%);
  }

  @include focus-state {
    &::before {
      inset: token('size/border/200');
      z-index: 1;
      border-radius: token('size/radius/m');
      box-shadow: 0 0 0 token('size/border/200') token('color/border/accent/focused/focused');
    }
  }
}
</style>
